class HighlightedTabs extends HTMLElement {
  constructor() {
    super();
    this.tabs = document.querySelectorAll('[data-recipe-title]');
    this.mainWrapper = document.querySelector('[data-highlighted-recipes-wrapper]');

    this.tabs.forEach((tab) => {
      if (tab.tagName.toLowerCase() !== 'option') {
        tab.addEventListener('click', () => this.handleTabClick(tab));
      } else {
        // Corrected the reference to 'this'
        tab.parentElement.addEventListener('change', (event) => {
          this.handleTabClick(event.target.options[event.target.selectedIndex]);
        });
      }
    });
  }

  handleTabClick(tab) {
    this.tabs.forEach((t) => t.classList.remove('tab-title--active'));

    // Add the active class to the clicked tab if it's not an <option>
    if (tab.tagName.toLowerCase() !== 'option') {
      tab.classList.add('tab-title--active');
    }

    const selectedTag = tab.getAttribute('data-tag') || tab.value;

    fetch(`/blogs/recepten/tagged/${selectedTag}?section_id=highlighted-recipes-filtered`)
      .then((response) => response.text())
      .then((data) => {
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(data, 'text/html');
        const wrapperElement = xmlDoc.querySelector('.swiper-wrapper');
        if (wrapperElement) {
          this.mainWrapper.innerHTML = wrapperElement.innerHTML;
        } else {
          console.error('Main element not found in the server response.');
        }
      })
      .catch((err) => console.error(err));
  }
}

if (!customElements.get('highlighted-tabs')) {
  customElements.define('highlighted-tabs', HighlightedTabs);
}
